import {
	Skeleton,
	SkeletonKpiRow,
	SkeletonTable,
} from "../../components/ui/Skeleton";

export function RebalanceSkeleton() {
	return (
		<div className="space-y-4">
			<DecisionBannerSkeleton />
			<SkeletonKpiRow
				count={3}
				className="grid grid-cols-2 gap-3 md:grid-cols-3"
			/>
			<div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
				<SkeletonTable
					rows={4}
					cols={3}
					withHeader={false}
					rowWidths={["w-2/3", "w-12", "w-1/4"]}
				/>
				<SkeletonTable
					rows={4}
					cols={5}
					rowWidths={["w-2/3", "w-1/4", "w-1/4", "w-1/4", "w-1/4"]}
				/>
			</div>
		</div>
	);
}

function DecisionBannerSkeleton() {
	return (
		<div className="flex items-center justify-between gap-3 rounded-lg border border-slate-800 bg-slate-900/40 p-4">
			<Skeleton className="h-5 w-44" />
			<Skeleton className="h-5 w-32 rounded-full" />
		</div>
	);
}
